// middleware/video-player.global.ts
export default defineNuxtRouteMiddleware((to) => {
  // Only run on client-side
  if (process.client) {
    // Check if the route requires video player
    const videoPlayerRoutes = ['/player', '/lesson']
    const requiresVideoPlayer = videoPlayerRoutes.some(route => to.path.startsWith(route))
    
    if (requiresVideoPlayer) {
      // Preload video player dependencies
      console.log('🎬 Video player route detected, preparing dependencies...')
      
      // You can preload HLS.js or other video dependencies here
      // This helps with performance on video-heavy pages
    }
  }
})
